import React from 'react';
import ReactApexChart from 'react-apexcharts';

const OverviewCharts = (item: any) => {
  const series = [
    {
      name: 'Quantity',
      data: item?.item?.Profit,
    },
    {
      name: ' ',
      data: item?.item?.Loss,
    },
  ];

  const colors = item?.item?.colors || ['#d0c016', '#34c38f'];

  const options: Object = {
    chart: {
      type: 'bar',
      height: 400,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: '20%',
        distributed: true,
      },
    },
    colors: colors,
    fill: {
      opacity: 1,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    yaxis: {
      labels: {
        formatter: function (y: any) {
          return y.toFixed(0);
        },
      },
    },
    xaxis: {
      categories: item?.item?.labels,
      labels: {
        rotate: -90,
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      className="apex-charts"
    />
  );
};

export default OverviewCharts;
